<app-search-bar (filterChanged)="emitFilter($event)"
                [fields]="fields"
                [formGroup]="form"
                [columnCount]="10"
                [key]="key">

  <div class="grid">
    <!--    <app-select>-->
    <!--      <mat-option *ngFor="let trigger of noticeTriggers$ | async">{{ trigger }}</mat-option>-->
    <!--    </app-select>-->

    <app-datetime-range formControlName="createdAt" [label]="'ORDERS.FILTERS.created' | translate"></app-datetime-range>

    <mat-form-field>
      <mat-label>{{ 'TABLE.recipient' | translate }}</mat-label>
      <input formControlName="recipient" matInput>
    </mat-form-field>
  </div>

</app-search-bar>
